import React from 'react';
import PropTypes from 'prop-types';
import { doGet } from '../../../utils/requests';
import './impressaoCronogramaPagamento.css';

const MENSAGENS = {
  noContentPrimary: 'Não foi possível consultar o cronograma.',
  noContentSecondary: 'Contate o administrador do sistema.',
  cronogramaNaoEncontrado: 'Cronograma não encontrado para a chave informada.',
  informeCronogramaValido: 'Informe um cronograma válido.',
};

const CLASSES_CSS = {
  esconderPrint: 'esconder-print',
  cabecalho: 'dtp-header',
  logoUsuario: 'user-target',
  footer: 'dtp-footer',
};

const STYLES_CSS = {
  painelGeral: {
    textAlign: 'center',
    margin: '0 auto',
  },
  painelCronograma: {
    display: 'inline-block',
    width: '460px',
    padding: '6px 6px',
  },
  itemCronograma: {
    display: 'flex',
    padding: '3px',
    borderRadius: '5px',
    color: 'white',
    height: '70px',
    verticalAlign: 'middle',
    marginBottom: '6px',
    boxShadow: '5px 4px 8px rgba(0, 0, 0, 0.8)',
  },
  itemCronogramaData: {
    display: 'inline-block',
    width: '71px',
    fontWeight: '500',
    fontSize: '20px',
    padding: '17px 6px 0',
    borderRight: '2px solid rgba(255, 255, 255, 0.9)',
    verticalAlign: 'middle',
    flexGrow: '1',
  },
  itemCronogramaDescricao: {
    display: 'inline-block',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontWeight: '600',
    paddingTop: '12px',
    fontSize: '15px',
    marginLeft: '10px',
    flexGrow: '0',
    width: '367px',
  },
};

const ITEMS = [
  {
    cor: 'rgba(0, 105, 177, 1)',
    descricao:
      'Consulta de débito dos entes federativos na RFB/PGFN e do contratação da Dataprev.',
  },
  {
    cor: 'rgba(133, 104, 90, 1)',
    descricao: 'Consulta de óbitos dos requerimentos do COMPREV.',
  },
  {
    cor: 'rgba(98, 103, 16, 1)',
    descricao: 'Fechamento da prévia da folha de pagamento do COMPREV.',
  },
  {
    cor: 'rgba(91, 155, 213, 1)',
    descricao: 'Início do período de consulta prévia da folha de pagamento.',
  },
  {
    cor: 'rgba(191, 103, 163, 1)',
    descricao: 'Fechamento da folha de pagamento do COMPREV.',
  },
  {
    cor: 'rgba(0, 95, 107, 1)',
    descricao: 'Disponibilização dos relatórios de pagamento com o fechamento.',
  },
  {
    cor: 'rgba(110, 91, 110, 1)',
    descricao: 'Envio do arquivo de pagamentos do RGPS ao Banco do Brasil.',
  },
  {
    cor: 'rgba(192, 80, 77, 1)',
    descricao: 'Prazo para pagamento dos valores devidos pelos regime.',
  },
  {
    cor: 'rgba(226, 148, 2, 1)',
    descricao: 'Marco Limite para Informar Rejeição de Pagamento.',
  },
  {
    cor: 'rgba(103, 181, 136, 1)',
    descricao: 'Marco Limite para Analisar Rejeição de Pagamento.',
  },
];
class InfoCronograma extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    infoCronogramaAberto: this.createCronograma(),
    infoCronogramaFechadoAntePenultimo: this.createCronograma(),
    infoCronogramaFechado: this.createCronograma(),
    dados: [],
    showNoContent: false,
    noContentPrimaryMessage: '',
    noContentSecondaryMessage: '',
  });

  componentDidMount() {
    this.buscaCronograma();
    this.mudarPrintClasses('add');
  }
  componentWillUnmount() {
    this.mudarPrintClasses('remove');
  }

  createCronograma = () => ({
    ano: null,
    mes: null,
    dataCND: null,
    dataObitos: null,
    dataFechamentoPrevia: null,
    dataConsultaPrevia: null,
    dataFechamentoFolha: null,
    dataRelatoriosBG: null,
    dataEnvioBB: null,
    dataPrazoPagamento: null,
    dataPrazoDefesa: null,
    dataPrazoAnalise: null,
    competencia: null,
  });
  mudarPrintClasses = (action) => {
    const elements = [
      document.getElementsByClassName(CLASSES_CSS.cabecalho)[0],
      document.getElementsByClassName(CLASSES_CSS.logoUsuario)[0],
      document.getElementsByClassName(CLASSES_CSS.footer)[0],
    ];
    elements.forEach((element) => {
      if (element) element.classList[action](CLASSES_CSS.esconderPrint);
    });
  };

  buscaCronograma = () => {
    const url = 'cronogramas-pagamento/painel-cronograma';
    doGet(url, this.handleSuccess, this.handleError);
  };

  handleSuccess = (response) => {
    if (response.data) {
      this.setState({
        dados: response.data,
        infoCronogramaAberto: {
          ...this.state.infoCronogramaAberto,
          ...response.data[0],
        },
        infoCronogramaFechado: {
          ...this.state.infoCronogramaFechado,
          ...response.data[1],
        },
        infoCronogramaFechadoAntePenultimo: {
          ...this.state.infoCronogramaFechadoAntePenultimo,
          ...response.data[2],
        },
      });
    }
  };
  handleError = (error) => {
    let mensagemPrimaria = MENSAGENS.noContentPrimary;
    let mensagemSecundaria = MENSAGENS.noContentSecondary;
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = MENSAGENS.cronogramaNaoEncontrado;
          mensagemSecundaria = MENSAGENS.informeCronogramaValido;
        }
      }
    }
    this.setState({
      ...this.state,
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };
  obterDiaMes = (data) => {
    if (data) {
      const lista = data.split('/');
      return `${lista[0]}/${lista[1]}`;
    }
    return '';
  };

  obterMesAno = (data) => {
    if (data) {
      const lista = data.split('/');
      return `${lista[1]}/${lista[2]}`;
    }
    return '';
  };
  gerarItem = (cor, data, descricao, index) => (
    <div
      key={index}
      style={{ ...STYLES_CSS.itemCronograma, backgroundColor: cor }}
      className={`imprimirCronograma${String(index)}`}
    >
      <div style={STYLES_CSS.itemCronogramaData}>{this.obterDiaMes(data)}</div>
      <div style={STYLES_CSS.itemCronogramaDescricao}>{descricao}</div>
    </div>
  );
  renderCronograma = (cronograma, titulo) => (
    <div style={STYLES_CSS.painelCronograma}>
      <h3 style={{ color: '#3060a0', fontSize: '22px', textAlign: 'left' }}>
        {titulo}: {cronograma.competencia}
      </h3>
      {ITEMS.map((item, index) =>
        this.gerarItem(
          item.cor,
          cronograma[Object.keys(cronograma)[index + 2]],
          item.descricao,
          index,
          ))}
    </div>
  );
  render() {
    const {
      infoCronogramaAberto,
      infoCronogramaFechado,
      infoCronogramaFechadoAntePenultimo,
    } = this.state;
    return (
      <React.Fragment>
        {this.state.dados.length > 0 && (
          <div style={STYLES_CSS.painelGeral}>
            <h2
              style={{ color: '#3060a0', fontSize: '24px', fontWeight: '600' }}
            >
              Cronograma Comprev
            </h2>
            {this.renderCronograma(
              infoCronogramaFechadoAntePenultimo,
              'Competência Fechada',
            )}
            {this.renderCronograma(
              infoCronogramaFechado,
              'Competência Fechada',
            )}
            {this.renderCronograma(infoCronogramaAberto, 'Competência Aberta')}
          </div>
        )}
      </React.Fragment>
    );
  }
}
InfoCronograma.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      mes1: PropTypes.string,
      ano1: PropTypes.string,
      mes2: PropTypes.string,
      ano2: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }),
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
};

InfoCronograma.defaultProps = {
  match: null,
  auth: null,
  history: null,
};

export default InfoCronograma;



// WEBPACK FOOTER //
// ./src/pages/cadastros/cronograma-pagamentos/InfoCronograma.jsx